import { useUser } from "./useUser"

export function useSubscriptionInfo() {
  const user = useUser()

  return user.subscription
}
